'use strict';
import React from 'react';
import { Navigation } from 'react-router';
import t from 'tcomb-form';
import flux from 'utils/flux';
import email from 'email-validation';
import classnames from 'classnames';
import { isEmpty } from 'lodash';

const { Form } = t.form;

const validation = flux.getStore('app').getState().config.get('validation').toJS();
var usernameValidation = t.Str;

if ( !isEmpty( validation ) && validation.username ) {
    if ( 'email' === validation.username ) {
        usernameValidation = t.subtype( t.Str, s => email.valid( s ) );
    }
    // else if ( 'object' === typeof validation.username && 'test' in validation.username ) {
    //     usernameValidation = t.subtype( t.Str, s => validation.username.test( s ) );
    // }
}

var Login = t.struct({
    email: usernameValidation,
    password: t.Str,
    remember_me: t.Bool
});

var LoginModal = React.createClass({
    displayName: 'LoginModal',
    mixins: [ Navigation ],
    propTypes: {
        hasError: React.PropTypes.oneOfType([
            React.PropTypes.string,
            React.PropTypes.bool
        ])
    },
    getInitialState() {
        return {
            email: '',
            password: '',
            remember_me: false
        };
    },
    showRegister(e) {
        e.preventDefault();
        flux.getActions('modals').openModal('Register');
    },
    showPasswordForgotten(e) {
        e.preventDefault();
        flux.getActions('modals').openModal('PasswordForgotten');
    },
    onChange(value) {
        this.setState({value});
    },
    onSubmit(evt) {
        evt.preventDefault();
        var { location } = this.props;
        var loginData = this.refs.form.getValue();
        if (loginData) {
            flux.getStore('app').loginUser(loginData).then(() => {
                flux.getActions('modals').closeModals();
                flux.getStore('basket').loadBaskets();
                var query = this.context.router.getCurrentQuery();
                if ( query.nextPath && query.nextPath.length > 1 ) {
                    this.transitionTo( query.nextPath, {} );
                }
                else {
                    this.replaceWith('landing-page');
                }
            });
        }
    },
    renderError() {
        if (this.props.hasError) {
            return (
                <div className="content__error">
                    {this.props.hasError}
                </div>
            );
        }
    },
    renderHelp() {
        const { supportLink } = flux.getStore('app').getState().config.toJS();
        if (supportLink.length) {
            return (
                <div className="login__support">
                    {flux.t('need_help')}
                    {' '}
                    <a href={supportLink} >{flux.t('email_us')}</a>
                </div>
            );
        }
    },

    renderRegistration() {
        const { hideRegistration } = flux.getStore('app').getState().config.toJS();
        if (!hideRegistration) {
            return (
                <div >
                    <div className="hint__label">{flux.t('no_account')}</div>
                    <a className="hint__link" href="#" onClick={this.showRegister}>{flux.t('apply_account')}</a>
                </div>
            );
        }
    },

    render() {
        var options = {
            fields: {
                email: {
                    error: flux.t('validation_email'),
                    label: flux.t('account_username'),
                    attrs: {
                        autoFocus: true
                    }
                },
                password: {
                    type: 'password',
                    label: flux.t('account_password'),
                    error: flux.t('validation_password')
                },
                remember_me: {
                    label: <span dangerouslySetInnerHTML={ { __html: flux.t('account_remember_me')} }></span>
                }
            }
        };

        return (
            <div>
                <h4>{flux.t('navigate_login')}</h4>
                <form onSubmit={this.onSubmit} className={classnames({'has-error': this.props.hasError})}>
                    <Form
                      ref="form"
                      type={Login}
                      options={options}
                      value={this.state.value}
                      onChange={this.onChange}
                    />
                    {this.renderError()}
                    <a href="#" className="login__forgotpassword" onClick={this.showPasswordForgotten}>{flux.t('password_forgotten')}</a>
                    <button className="login__button btn btn-primary btn-arrow" type="submit">
                        {flux.t('navigate_login')}
                        <i className="chevron-right" />
                    </button>
                    <div className="login__hint">
                        <hr className="white" />
                        {this.renderRegistration()}
                        {this.renderHelp()}
                    </div>
                </form>
            </div>
        );
    }
});

module.exports = LoginModal;



// WEBPACK FOOTER //
// ./app/components/modals/loginModal.jsx